import clsx from 'clsx';
import React from 'react';

import { useFeatureFlags } from 'src/context/flagsContext';
import { InboxPageContext } from 'src/context/inboxPageContext';
import { useContextBar } from 'src/hooks/useContextBar';
import { LoadingWrapper } from 'src/legacy/components/Loading';
import { useGetInboxNotificationsQuery } from 'src/services/api/inboxApi';

import { InboxContent } from './InboxContent';
import { InboxSidebar } from './InboxSidebar';

export const InboxPage = () => {
  const { EnableContextBarOtherPage } = useFeatureFlags();
  const { open: contextBarOpen } = useContextBar();

  const { isLoading: areAllNotificationsLoading } =
    useGetInboxNotificationsQuery();

  const [selectedNotification, setSelectedNotification] = React.useState(null);

  const inboxPageContextValue = React.useMemo(
    () => ({
      selectedNotification,
      setSelectedNotification,
    }),
    [selectedNotification, setSelectedNotification],
  );

  return (
    <InboxPageContext.Provider value={inboxPageContextValue}>
      <LoadingWrapper
        hideContentWhileLoading
        isLoading={areAllNotificationsLoading}
      >
        <div
          className={clsx(
            'h-full flex',
            !(EnableContextBarOtherPage && contextBarOpen) && 'overflow-hidden',
          )}
        >
          <InboxSidebar />
          <InboxContent />
        </div>
      </LoadingWrapper>
    </InboxPageContext.Provider>
  );
};
